import { REACT_URL } from "@/common/config-local"

const DEBUG=false
const BILLING_DEBUG = "http://localhost:3001/"
const BILLING_PROD = "https://billing.domagolf.com/"

export const BILLING = DEBUG ? BILLING_DEBUG : BILLING_PROD

// Screens already migrated to the React middleware are linked from this menu
// rather than routed here. The React app is served under a `/v2` basePath in
// every environment (BASE_PATH in its .env), so the prefix belongs in the URL —
// leaving it out is what made the Shops entry dead.
//
// ⚠️ Tirée de config-local.js (propre à chaque environnement), comme les
// redirections de routes.js. Elle dépendait de DEBUG, écrit en dur à false :
// en local, le login et le menu Options renvoyaient vers la PROD.
export const MIDDLEWARE_REACT = REACT_URL.replace(/\/$/, "") + "/"
